import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { FilterBar, TableData } from '../../../../components';
import { errorAlert } from '../../../../helpers/alerts';
import { setPanel } from '../../../../redux/slices/route/routeSlice';
import { getPDSRuteoService, setPDSProviderCredentialService } from '../../../../services/roteo/routeService';
import { setLoading } from 'redux/slices/uiSlice';
import { getAllCredPDSProductsService } from 'services/admin/providerService';
import { setPDSProducts, setPDSSegments } from 'redux/slices/admin/productSlice';
import { getAllPDSProductsService, getPDSSegmentsService } from 'services/admin/productService';

const PDSRouteScreen = () => {
  const dispatch = useDispatch();
  const { panel } = useSelector(store => store.route)
  const { pdsProducts, pdsSegments } = useSelector((state) => state.products);
  const [providers, setProviders] = useState([])
  const [rows, setRows] = useState([])

  const asList = (value) => (Array.isArray(value) ? value : []);

  useEffect(() => {
    getAllPDSProductsService()
      .then(data => {
        dispatch(setPDSProducts(data))
        setRows(asList(data))
      }).catch(error => errorAlert(error))
    getPDSSegmentsService()
      .then(data => dispatch(setPDSSegments(data)))
      .catch(error => errorAlert(error))
    getAllCredPDSProductsService()
      .then(response => setProviders(response))
      .catch(error => errorAlert(error))
    getPDSRuteoService()
      .then(response => dispatch(setPanel(response)))
      .catch(error => errorAlert(error));
    // eslint-disable-next-line
  }, []);

  const handlerSubmit = (values) => {
    if (!values.segment) return setRows(asList(pdsProducts))
    setRows(asList(pdsProducts).filter((item) => item?.idSegment?.id == values.segment))
  }

  const handlerChangePrimaryProvider = async (idCredential, product) => {
    dispatch(setLoading(true));
    setPDSProviderCredentialService({ idCredential, idProduct: product.id })
      .then(response => dispatch(setPanel(response)))
      .catch(error => errorAlert(error))
      .finally(() => dispatch(setLoading(false)));
  }

  const setList = (product, otherProvider) => {
    const result = asList(providers).filter((item) => (
      item?.idProduct?.id == product && item?.idCredential?.id
    )).map(({ idCredential }) => ({
      id: idCredential.id,
      name: idCredential.name_connector ?? '-'
    }))
    return [
      { id: 'null', name: 'Sin asignar', operadoras: [] },
      ...result
    ]
  }

  return (
    <>
      <FilterBar
        showTitle={false}
        handlerFilter={handlerSubmit}
        allValue={null}
        filters={[
          {
            name: 'segment',
            label: "Segmento",
            type: "select",
            all: 'Todos',
            data: asList(pdsSegments),
          }
        ]}
      />
      <TableData
        rowsPerPageOpt={1000}
        pagination={false}
        dataRows={asList(rows).filter(item => {
          return setList(item?.id).length > 1
        }).map(item => ({
          ...item,
          primaryProvider: asList(panel).find((row) => row?.product?.id == item?.id)?.primaryProvider,
        }))}
        dataTitle={[
          "Logo",
          "Nombre",
          "Segmento",
          "Proveedor Primario",
        ]}
        formatter={({ id, fd, name, idSegment, primaryProvider }) => [
          { type: "img", value: `/v3/file/${fd}/` },
          name,
          idSegment?.name ?? '-',
          {
            name: "provider_primary",
            type: "select_button",
            label: 'Proveedor',
            list: setList(id),
            value: asList(providers).length == 0 ? null : (primaryProvider || 'null'),
            onChange: handlerChangePrimaryProvider
          },
        ]}
      />
    </>
  )
}

export default PDSRouteScreen